import apiClient from './apiClient';
import API_ENDPOINTS from '../Api/endpoints';

// Fetch organizations filtered by type=CUSTOMER
export const fetchCustomerOrganisations = async () => {
  const url = `${API_ENDPOINTS.ORGANISATIONS.LIST}?type=CUSTOMER`;
  const { data } = await apiClient.get(url);
  // Normalize to { id, name }
  const list = Array.isArray(data) ? data : [];
  return list.map((o) => {
    const id = o.id || o.organisationId || o.organizationId || o.uuid || o.organisationUUID || o.orgId;
    const name = o.name || o.organisationName || o.organizationName || o.displayName || o.title || String(id);
    return { id, name, raw: o };
  }).filter((o) => !!o.id);
};
